import styled, { css } from 'styled-components'
import { Flex } from 'components/common/styles'
import { GRAY5, PRIMARY_TEXT } from 'constants/colors'

export const ItemHeader = styled(Flex)`
  padding-right: 10px;
`

export const ManagementUICol = styled(Flex).attrs(() => ({
  align: 'center',
  justify: 'left',
}))`
  position: relative;
  z-index: 1;
  text-align: center;
  text-transform: capitalize;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  min-width: 155px;
  width: 155px;
  padding-left: 10px;
  color: ${PRIMARY_TEXT};
`

export const NameCol = styled(ManagementUICol)`
  width: 100%;
  min-width: 344px;
  text-align: left;
  justify-content: flex-start;
  padding-left: 0;
`

export const NameColTask = styled(NameCol)`
  cursor: text;
  min-width: 280px;
`

export const ConfigureCol = styled(ManagementUICol)`
  justify-content: center;
  min-width: 24px;
  width: 24px;
  padding-left: 0;

  svg {
    cursor: pointer;
  }
`

export const RecurrenceCol = styled(ManagementUICol)`
  text-transform: capitalize;
  min-width: 200px;
`

export const MediaCol = styled(ManagementUICol)`
  svg {
    margin-left: 4px;
    stroke: ${GRAY5};
  }
`

export const TasksCompletedCol = styled(ManagementUICol)`
  min-width: 150px;
  width: 150px;
`

export const IconWrapper = styled.div<{ sortByStatusDirection: boolean }>`
  ${({ sortByStatusDirection }) =>
    sortByStatusDirection &&
    css`
      rotate: 180deg;
    `}
`
